import { withStyles } from '@material-ui/core';
import PlainCartItem from './PlainCartItem';

const styles = ({ palette, transitions }) => ({
    item: {
        '&:hover': {
            backgroundColor: palette.grey[200],
            transition: transitions.create(['background-color'], { duration: transitions.duration.complex }),
        },
    },
});

export default withStyles(styles)(PlainCartItem);
